import React from 'react';
import './Spacer.css';

const Spacer = ({ size = 'small' }) => {
  return <div className={`spacer ${size}`} />;
};

export default Spacer;
